import React from 'react'

import PropTypes from 'prop-types'

import Tooltip from '../Tooltip'

const TooltipMenu = ({ children, icon, ...rest }) => {
  return (
    <>
      <Tooltip content={children} {...rest}>
        {icon}
      </Tooltip>
    </>
  )
}

TooltipMenu.propTypes = {
  icon: PropTypes.object.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.array,
    PropTypes.bool
  ])
}

export default TooltipMenu
